<template>
  <div class="messageBox sub-main" v-loading="loading">
    <div class="top2">
        <div class="left">
            <div class="headImg">
                <img :src="userInfo.headImage" alt="">
            </div>
            <div class="info">
                <div>{{userInfo.phone}}</div>
                <div>{{userInfo.name}}</div>
            </div>
        </div>
        <div class="right">
            <img src="../../../assets/images/userCard.png" alt="">
            <div class="showMoney">
                <div>累计节省</div>
                <div>0</div>
            </div>
            <div class="showMoney">
                <div>累计消费</div>
                <div>0</div>
            </div>
        </div>
    </div>
    <div class="bottom2">
        <h2 style="font-size:20px;margin-top:20px;font-weight:600;">购买情况</h2>
        <div class="box">
            <div class="item">
                <img src="../../../assets/images/orderPrice.png" alt="">
                <span>订单平均价格</span>
                <div class="price">0</div>
            </div>
            <div class="item">
                <img src="../../../assets/images/buyNumber.png" alt="">
                <span>购买数量</span>
                <div class="price">0</div>
            </div>
            <div class="item">
                <img src="../../../assets/images/orderTotal.png" alt="">
                <span>订单总数</span>
                <div class="price">0</div>
            </div>
            <div class="item">
                <img src="../../../assets/images/dealNumber.png" alt="">
                <span>签署合同数</span>
                <div class="price">0</div>
            </div>
            <div class="item">
                <img src="../../../assets/images/favorablePrice.png" alt="">
                <span>优惠金额</span>
                <div class="price">0</div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import { listSearchMixin } from "@/config/mixin";
import { mapGetters, mapMutations } from "vuex";


export default {
  name: "personCenter",
  mixins: [listSearchMixin],
  components:{
      
  },
  data() {
    return {
        stateFlag:true,
        rowdata:'',
      tableData: [
       
      ],
      userInfo:{},
      messageList: [],
      page: 1,
      pageSize: 10,
      shopName:"",
      total: 1,
      flag: true,
      loading: false,
    };
  },
  mounted() {
    
    this.getUserInfo();
  },
  computed: {
    ...mapGetters([
      "userInfo", // 用户信息
    ]),
    
  },
  methods: {
    ...mapMutations({
      setUserInfo: "SET_USERINFO",
    }),
   
    getFlag(data){
        this.stateFlag = data
        console.log(data)
    },
   
  
    // 获取用户信息
    getUserInfo() {
      let self = this;
      let params = {
        url: api.getUserInfo,
        method: "post",
        data: {
          buyerUserId: this.userInfo.buyerUserId,
        },
      };
      self.sendReq(params, (res) => {
        
        if (res.code === "200") {
          self.setUserInfo(res.data);
        } else {
          self.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    // 翻页
    handleCurrentChange(val) {
      this.page = val;
      this.getAll();
    },
    // 查看详情
    goToDetail(item) {
      if (item.noticeType === 1) {
        if (item.jump === 0) {
          this.$router.push({
            path: "/notificationDetails",
            query: {
              id: item.noticeId,
            },
          });
        } else if (item.jump === 1) {
          this.$router.push({
            path: "/notificationDetails",
            query: {
              id: item.noticeId,
            },
          });
        } else if (item.jump === 2) {
          this.$router.push({
            path: "/orderDetail",
            query: {
              orderId: item.only,
              noticeId: item.noticeId,
            },
          });
        }
      } else if (item.noticeType === 3) {
        this.$router.push({
          path: "/notificationDetails",
          query: {
            id: item.noticeId,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.top2{
    width: 100%;
    display: flex;
    justify-content: left;
    .left{
        padding-top:70px;
        width: 30%;
        height: 212px;
        margin:auto 0;
        display: flex;
        justify-content: left;
        .headImg{
            width: 80px;
            height: 80px;
            border-radius: 50%;
            img{
                width: 100%;
                overflow: hidden;
            }
        }
        .info{
            margin-left: 40px;
            margin-top:10px;
            div{
                
                font-size: 18px;
                font-weight: bold;
                color: #333333;
            }
        }
    }
    .right{
        width: 70%;
        display: flex;
        justify-content: left;
        position: relative;
        padding: 80px 100px;
        img{
            width: 100%;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 99;
        }
        .showMoney{
             z-index: 199;
             margin-right: 200px;
             div{
                 color: #ffffff;
                 &:nth-child(1){
                    font-size: 18px;

                 }
                 &:nth-child(2){
                     font-size: 26px;
                 }
             }
        }
    }
}
.bottom2{
    .box{
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-top: 30px;
        .item{
            width: 18%;
            background-color: #fff;
            box-shadow: 0px 5px 10px 0px rgba(231, 234, 235, 0.93);
            border-radius: 8px;
            padding: 10px;
            img{
                width: 30px;
                height: 30px;
                margin-right: 10px;
            }
            .price{
                font-size: 26px;
                font-weight: bold;
                color: #000000;
                margin-left: 45px;
            }
            span{
                font-size: 16px;
            }
        }
    }
}
.messageBox {
  // border: 1px solid #E5E5E5;
  padding: 30px;
  .messageList {
    .itemBox {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #e5e5e5;
      margin-bottom: 30px;
      padding-bottom: 20px;
      .icon {
        width: 56px;
        height: 56px;
        border-radius: 50%;
        background: #348bfa;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        font-size: 26px;
        margin-right: 30px;
      }
      .color {
        background: #f75c61;
      }
      .messageTitle {
        h3 {
          color: #333333;
          font-size: 14px;
          margin-bottom: 20px;
          cursor: pointer;
        }
        span {
          color: #666666;
          font-size: 12px;
        }
      }
    }
  }
}
.sub-main {
  min-height: 400px;
}
.nothing {
  width: 100%;
  text-align: center;
  min-height: 400px;
  p {
    margin-bottom: 20px;
  }

  //   .el-button {
  //     background-color: #ff7800;
  //     color: #ffffff;
  //     font-weight: normal;
  //     border-radius: 0;
  //   }
}
.btn {
  border: 1px solid #e5e5e4 !important;
  font-size: 14px;
  outline: none;
  color: #999999 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/userCenter/center/personCenter.vue